import { render } from "./QnaV2.vue?vue&type=template&id=98909cc4&scoped=true"
import script from "./QnaV2.vue?vue&type=script&lang=js"
export * from "./QnaV2.vue?vue&type=script&lang=js"

import "./QnaV2.vue?vue&type=style&index=0&id=98909cc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98909cc4"]])

export default __exports__